import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'
import { ConceptStatusValue, primitiveValue } from '@fusion-advantage/backcompat'

export const ValueFunction: HelperFunction = {
	tokenName: 'VALUE',
	nodeType: functionNodeTypes.Value,
	evaluate(node, evaluateExpr, context) {
		const args = node.arguments
		if (args.length < 1 || args.length > 2) {
			return err(evaluatorErrorWithNode('VALUE function expects one or two arguments', node))
		}
		const conceptResult = evaluateExpr(args[0])
		if (conceptResult.isErr()) return err(conceptResult.error)
		if (typeof conceptResult.value !== 'string') {
			return err(evaluatorErrorWithNode('VALUE function first argument must evaluate to a string', node))
		}
		let value: ConceptStatusValue
		if (args[1]) {
			const subconceptResult = evaluateExpr(args[1])
			if (subconceptResult.isErr()) return err(subconceptResult.error)
			if (typeof subconceptResult.value !== 'string') {
				return err(evaluatorErrorWithNode('VALUE function second argument must evaluate to a string', node))
			}
			value = context.substatusValue(conceptResult.value, subconceptResult.value)
		} else {
			value = context.statusValue(conceptResult.value)
		}
		// calc engine doesn't handle complex objects
		const rPrimitive = primitiveValue(value)
		if(rPrimitive.isErr()) {
			return err(evaluatorErrorWithNode(`VALUE function expects primitive status value`, node))
		}
		return ok(rPrimitive.value)
	}
}
